import { MIN_INSIGHT_POSTS } from './insightThresholds';

export type InsightCardState = 'shortRange' | 'loading' | 'error' | 'notEnough' | 'ready';

/**
 * Which body an insight card shows. The 7-day range can never hold a post that is at least
 * 7 days old, so it always asks for a longer period. Cached data wins over a later error.
 */
export function resolveInsightCardState({ range, eligiblePosts, error }: {
  range: string;
  eligiblePosts: number | null;
  error: boolean;
}): InsightCardState {
  if (range === 'D7') return 'shortRange';
  if (eligiblePosts === null) return error ? 'error' : 'loading';
  return eligiblePosts < MIN_INSIGHT_POSTS ? 'notEnough' : 'ready';
}
